import * as Draft from 'draft-js';
import * as DraftJsButtons from 'draft-js-buttons';
import * as React from 'react';
import { Omit } from 'src/definitions';
import Toolbar, { ToolbarProps } from './components/Toolbar';
import createStore from './utils/createStore';

require('./css/buttonStyles.css');
require('./css/blockTypeSelectStyles.css');
require('./css/toolbarStyles.css');

const buttonStyles = {
  buttonWrapper: 'buttonWrapper',
  button: 'button',
  active: 'active',
  separator: 'separator'
};

const blockTypeSelectStyles = {
  blockType: 'blockType',
  spacer: 'spacer',
  popup: 'popup'
};

const toolbarStyles = {
  wrapper: 'wrapper'
};

export interface SideToolbarStore {
  isVisible: boolean;
  editorState: Draft.EditorState;
  getEditorRef: () => React.Ref<unknown>;
  getEditorState: () => Draft.EditorState;
  setEditorState: (editorState: Draft.EditorState) => void;
}

export interface SideToolbarConfig {
  position?: 'right' | 'left';
  theme?: DraftJsButtons.Theme;
}

const createSideToolbarPlugin = (config: SideToolbarConfig = {}) => {
  const defaultPosition = 'left';

  const defaultTheme = { buttonStyles, blockTypeSelectStyles, toolbarStyles };

  const store = createStore({
    isVisible: false,
    editorState: Draft.EditorState.createEmpty(),
    getEditorRef: ((() => {}) as unknown) as any,
    getEditorState: () => Draft.EditorState.createEmpty(),
    setEditorState: (editorState: Draft.EditorState) => {}
  });

  const { position = defaultPosition, theme = defaultTheme } = config;

  const toolbarProps = {
    store,
    theme,
    position
  };

  return {
    initialize: ({
      setEditorState,
      getEditorState,
      getEditorRef
    }: {
      getEditorRef: () => React.Ref<unknown>;
      getEditorState: () => Draft.EditorState;
      setEditorState: (editorState: Draft.EditorState) => void;
    }) => {
      store.updateItem('getEditorState', getEditorState);
      store.updateItem('setEditorState', setEditorState);
      store.updateItem('getEditorRef', getEditorRef);
    },
    // Re-Render the toolbar on every change
    onChange: (editorState: Draft.EditorState) => {
      store.updateItem('editorState', editorState);

      return editorState;
    },
    SideToolbar: (props: Omit<ToolbarProps, keyof typeof toolbarProps>) => (
      <Toolbar {...props} {...toolbarProps} />
    )
  };
};

export default createSideToolbarPlugin;
